/* AF Racing 2.0 - revelado por scroll + contadores. Compartido por las secciones af-*. */
(function () {
  if (window.__afRacing) return;
  window.__afRacing = true;

  var sinAnim = !('IntersectionObserver' in window) ||
    (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    (window.Shopify && Shopify.designMode);

  function cuenta(el) {
    var fin = parseInt(el.getAttribute('data-af-count'), 10) || 0;
    var dur = 1300, t0 = performance.now();
    function paso(t) {
      var p = Math.min(1, (t - t0) / dur), suave = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(fin * suave).toLocaleString('es-MX');
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function muestraTodo(raiz) {
    (raiz || document).querySelectorAll('.af-rev').forEach(function (el) { el.classList.add('af-vis'); });
    (raiz || document).querySelectorAll('[data-af-count]').forEach(function (el) {
      el.textContent = (parseInt(el.getAttribute('data-af-count'), 10) || 0).toLocaleString('es-MX');
    });
  }

  function observa(raiz) {
    if (sinAnim) { muestraTodo(raiz); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('af-vis');
          e.target.querySelectorAll('[data-af-count]').forEach(cuenta);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    (raiz || document).querySelectorAll('.af-rev').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observa(document); });
  } else {
    observa(document);
  }

  document.addEventListener('shopify:section:load', function (e) { muestraTodo(e.target); });
})();